import React from 'react'
import AccountContainer from './containers/AccountContainer'

function Account() {
  return <AccountContainer />
}

export default Account

